(function(angular, module) {var ActivityDetailsController, ActivityOverviewController, ActivityReportBaseController, buildDownloadURL;

ActivityReportBaseController = function($controller, $scope, program, activityTypes, ApiUrl) {
  "ngInject";
  var emitter, url;
  this.program = program;
  this.activityTypes = activityTypes;
  emitter = $controller('TagRefreshEmitter', {
    $scope: $scope
  });
  angular.extend(this, emitter);
  url = ApiUrl.partial('report', 'activity');
  if (program != null) {
    url = url.partial(program.id);
  }
  $scope.$on('tagRefresh', (function(_this) {
    return function(event, params) {
      var tags;
      tags = buildDownloadURL(params);
      _this.downloadUrl = url('activities.xlsx') + '?' + tags;
    };
  })(this));
};

ActivityOverviewController = function($scope, $http, activityTypes, Debouncer, ApiUrl, program) {
  "ngInject";
  var refresh, setData, url;
  url = ApiUrl.partial('report', 'activity');
  if (program != null) {
    url = url.partial(program.id);
  }
  this.data = {};
  this.activityTypes = activityTypes;
  this.params = null;
  $scope.$emit('requestTagParams');
  $scope.$on('tagRefresh', (function(_this) {
    return function(event, params) {
      _this.params = params;
      return refresh.call();
    };
  })(this));
  refresh = new Debouncer((function(_this) {
    return function() {
      return $http.get(url(), {
        params: _this.params
      }).then(setData);
    };
  })(this));
  setData = (function(_this) {
    return function(response) {
      var i, len, num, ref, type;
      _this.students = response.data.student_count || 0;
      _this.programs = response.data.program_count || 0;
      ref = _this.activityTypes;
      for (i = 0, len = ref.length; i < len; i++) {
        type = ref[i];
        num = response.data.activities[type] || 0;
        _this.data[type] = _this.data[type] || [0, 1];
        _this.data[type][0] = num;
        _this.data[type][1] = _this.students - num;
        if (num === 0 && _this.students === 0) {
          _this.data[type][1] = 1;
        }
      }
    };
  })(this);
};

ActivityDetailsController = function($scope, $state, $http, $stateParams, activityTypes, mentoringTypes, program, Debouncer, ApiUrl) {
  'ngInject';
  var findMax, setData, url;
  this.activityTypes = activityTypes;
  this.type = $stateParams.type;
  if (this.type === 'mentoring') {
    this.mentoringTypes = mentoringTypes;
  }
  this.loading = true;
  url = ApiUrl.partial('report', 'activity', this.type);
  if (program != null) {
    url = url.partial(program.id);
  }
  this.tags = {};
  this.sort = $stateParams.sort;
  this.page = $stateParams.page;
  $scope.$emit('requestTagParams');
  $scope.$on('tagRefresh', (function(_this) {
    return function(event, params) {
      _this.tags = params;
      return _this.refresh.call();
    };
  })(this));
  this.makeParams = function(base) {
    base.type = this.type;
    angular.extend(base, this.tags);
    return base;
  };
  this.refresh = new Debouncer((function(_this) {
    return function() {
      var params;
      _this.loading = true;
      params = angular.copy(_this.tags);
      params.sort = _this.sort;
      params.page = _this.page;
      $state.go('.', params, {
        location: 'replace'
      });
      return $http.get(url(), {
        params: params
      }).then(setData);
    };
  })(this));
  setData = (function(_this) {
    return function(response) {
      _this.items = response.data.items;
      _this.totals = response.data.totals;
      _this.pager = response.data.pager;
      _this.maxNumerator = findMax(_this.items, 'numerator');
      _this.maxDenominator = findMax(_this.items, 'denominator');
      return _this.loading = false;
    };
  })(this);
  findMax = function(items, field) {
    var get;
    get = function(val, item) {
      if (item[field] && val < item[field]) {
        return item[field];
      } else {
        return val;
      }
    };
    return items.reduce(get, 0);
  };
};

buildDownloadURL = function(tags) {
  var i, len, parts, ref, slug, tag;
  parts = [];
  for (slug in tags) {
    ref = tags[slug];
    for (i = 0, len = ref.length; i < len; i++) {
      tag = ref[i];
      parts.push(slug + "=" + (encodeURIComponent(tag)));
    }
  }
  return parts.join('&');
};

module.controller('ActivityReportBaseController', ActivityReportBaseController).controller('ActivityOverviewController', ActivityOverviewController).controller('ActivityDetailsController', ActivityDetailsController);
})(angular, angular.module("dybReportActivity"));